function TermsAndPrivacy({ srcUrl, setIsOpen }: TermsAndPrivacyProps) {
  return (
    <>
      <div
        className="fixed inset-0 z-[999] bg-white flex w-full justify-center pt-14 px-5 mx-auto max-w-[820px]"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="p-2 text-lg absolute top-2 right-2 text-black" onClick={() => setIsOpen(false)}>
          Close
        </button>
        <div className="w-full h-full">
          <iframe src={srcUrl} className="w-full h-full" />
        </div>
      </div>
    </>
  )
}

interface TermsAndPrivacyProps {
  srcUrl: string
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export default TermsAndPrivacy
